export const Types = {
  SET_COMPANY_INFO: "SET_COMPANY_INFO",
  INITIATE_API_CALL: "INITIATE_API_CALL",
  SET_SHOW_REPORT: "SET_SHOW_REPORT"
};

export const setCompanyInfo = companyInfo => ({
  type: Types.SET_COMPANY_INFO,
  payload: companyInfo,
});

export const initiateApiCall = () => ({
  type: Types.INITIATE_API_CALL,
});

export const setShowReport = showreport =>({
  type: Types.SET_SHOW_REPORT,
  payload:showreport,
});
